<template>
  <base-comment-input
    ref="baseCommentRef"
    @insertComment="insertComment"
  ></base-comment-input>
</template>

<script>
  import vbCommentService from "../../../services/vbCommentService";
  import uploadFileMixin from "../../doc-in/uploadFileMixin";
  import FileTypeImage from "../../job/FileTypeImage";
  import BaseCommentInput from "./base-comment-input";

  export default {
    name: "hc-command-comment-input",
    props: ["hcCaseCommandsId","hcType"],
    components: {BaseCommentInput, FileTypeImage},
    mixins: [uploadFileMixin],

    data() {
      return {
        content: null,
        vbAttachments: []
      };
    },

    methods: {
      insertComment({content, attachmentIds}) {
        let submitForm = {
          content,
          attachmentIds,
          objectId: this.hcCaseCommandsId
        };
        
        if(this.hcType === 'KLCD'){
                  return vbCommentService
          .commentForHcCommand(submitForm)
          .then(response => {
            let vbComment = response.data;
            this.$refs.baseCommentRef.resetFormAfterSubmitComment();
            this.$emit("commentSuccess", {vbComment})
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
        }

        if(this.hcType === 'CVTT'){
        return vbCommentService
          .commentForHcCongViecTrongTam(submitForm)
          .then(response => {
            let vbComment = response.data;
            this.$refs.baseCommentRef.resetFormAfterSubmitComment();
            this.$emit("commentSuccess", {vbComment})
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
        }

        if(this.hcType === 'QCQD'){
        return vbCommentService
          .commentForHcQuyCheQuyDinh(submitForm)
          .then(response => {
            let vbComment = response.data;
            this.$refs.baseCommentRef.resetFormAfterSubmitComment();
            this.$emit("commentSuccess", {vbComment})
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
        }

      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-command-comment-input.vue